<script>
/**
 * Vitals Component
 */
export default {
  data() {
    return {
      months: [
        'January', 'February', 'March', 'April', 'May', 'June', 
        'July', 'August', 'September', 'October', 'November', 'December'
      ],
      timeframeOptions: [
        { value: 'all', text: 'All Year' },
        { value: 'current', text: 'Current Month' },
        { value: 'January', text: 'January' },
        { value: 'February', text: 'February' },
        { value: 'March', text: 'March' },
        { value: 'April', text: 'April' },
        { value: 'May', text: 'May' },
        { value: 'June', text: 'June' },
        { value: 'July', text: 'July' },
        { value: 'August', text: 'August' },
        { value: 'September', text: 'September' },
        { value: 'October', text: 'October' },
        { value: 'November', text: 'November' },
        { value: 'December', text: 'December' }
      ],
      chartColors: ['#556ee6', '#34c38f', '#f1b44c', '#50a5f1'],
      selectedTimeframe: 'current', // Default to current month
      vitalsData: [
        {
          title: "BP Levels",
          icon: "fas fa-capsules",
          value: "135/90",
          subvalue: "2.4%",
          selectedTimeframe: 'current', // Individual selection for each vital
          yearlyData: {
            // Full year data for line chart
            data: [
              { month: 'Jan', value: 132 },
              { month: 'Feb', value: 128 },
              { month: 'Mar', value: 130 },
              { month: 'Apr', value: 135 },
              { month: 'May', value: 138 },
              { month: 'Jun', value: 142 },
              { month: 'Jul', value: 140 },
              { month: 'Aug', value: 138 },
              { month: 'Sep', value: 135 },
              { month: 'Oct', value: 132 },
              { month: 'Nov', value: 130 },
              { month: 'Dec', value: 135 }
            ]
          },
          // Monthly data for each month (current month is December in this example)
          monthlyData: {
            'January': [128, 130, 126, 129],
            'February': [130, 132, 128, 131],
            'March': [132, 134, 130, 133],
            'April': [134, 136, 132, 135],
            'May': [136, 138, 134, 137],
            'June': [138, 140, 136, 139],
            'July': [140, 142, 138, 141],
            'August': [138, 140, 136, 139],
            'September': [136, 138, 134, 137],
            'October': [134, 136, 132, 135],
            'November': [132, 134, 130, 133],
            'December': [135, 130, 138, 132]
          },
          chartData: {
            series: [{
              name: "Current Month",
              data: [135, 130, 138, 132]
            }],
            chartOptions: {
              chart: {
                height: 150,
                type: 'bar',
                zoom: {
                  enabled: false
                },
                toolbar: {
                  show: false
                }
              },
              colors: ['#556ee6'],
              dataLabels: {
                enabled: false,
              },
              stroke: {
                width: [2],
                curve: 'smooth'
              },
              plotOptions: {
                bar: {
                  horizontal: false,
                  columnWidth: '45%',
                  endingShape: 'rounded'
                },
              },
              grid: {
                row: {
                  colors: ['transparent', 'transparent'],
                  opacity: 0.2
                },
                borderColor: '#f1f1f1'
              },
              markers: {
                size: 3
              },
              xaxis: {
                categories: ['Week 1', 'Week 2', 'Week 3', 'Week 4'],
                labels: {
                  show: false
                },
                axisBorder: {
                  show: false
                },
                axisTicks: {
                  show: false
                }
              },
              yaxis: {
                labels: {
                  show: false
                }
              },
              legend: {
                show: false
              },
              tooltip: {
                shared: true,
                intersect: false,
                y: {
                  formatter: function (y) {
                    if (typeof y !== "undefined") {
                      return y.toFixed(0) + " mmHg";
                    }
                    return y;
                  }
                }
              }
            }
          }
        },
        {
          title: "Sugar Levels",
          icon: "ri-contrast-drop-2-line",
          value: "140",
          subvalue: "1.8%",
          selectedTimeframe: 'current', // Individual selection for each vital
          yearlyData: {
            // Full year data for line chart
            data: [
              { month: 'Jan', value: 135 },
              { month: 'Feb', value: 142 },
              { month: 'Mar', value: 148 },
              { month: 'Apr', value: 145 },
              { month: 'May', value: 150 },
              { month: 'Jun', value: 155 },
              { month: 'Jul', value: 160 },
              { month: 'Aug', value: 158 },
              { month: 'Sep', value: 152 },
              { month: 'Oct', value: 148 },
              { month: 'Nov', value: 145 },
              { month: 'Dec', value: 140 }
            ]
          },
          // Monthly data for each month (current month is December in this example)
          monthlyData: {
            'January': [132, 135, 138, 140],
            'February': [140, 142, 145, 148],
            'March': [145, 148, 150, 152],
            'April': [142, 145, 148, 150],
            'May': [148, 150, 152, 155],
            'June': [152, 155, 158, 160],
            'July': [158, 160, 162, 165],
            'August': [155, 158, 160, 162],
            'September': [150, 152, 155, 158],
            'October': [145, 148, 150, 152],
            'November': [142, 145, 148, 150],
            'December': [140, 150, 160, 145]
          },
          chartData: {
            series: [{
              name: "Current Month",
              data: [140, 150, 160, 145]
            }],
            chartOptions: {
              chart: {
                height: 150,
                type: 'bar',
                zoom: {
                  enabled: false
                },
                toolbar: {
                  show: false
                }
              },
              colors: ['#556ee6'],
              dataLabels: {
                enabled: false,
              },
              stroke: {
                width: [2],
                curve: 'smooth'
              },
              plotOptions: {
                bar: {
                  horizontal: false,
                  columnWidth: '45%',
                  endingShape: 'rounded'
                },
              },
              grid: {
                row: {
                  colors: ['transparent', 'transparent'],
                  opacity: 0.2
                },
                borderColor: '#f1f1f1'
              },
              markers: {
                size: 3
              },
              xaxis: {
                categories: ['Week 1', 'Week 2', 'Week 3', 'Week 4'],
                labels: {
                  show: false
                },
                axisBorder: {
                  show: false
                },
                axisTicks: {
                  show: false
                }
              },
              yaxis: {
                labels: {
                  show: false
                }
              },
              legend: {
                show: false
              },
              tooltip: {
                shared: true,
                intersect: false,
                y: {
                  formatter: function (y) {
                    if (typeof y !== "undefined") {
                      return y.toFixed(0) + " mg/dL";
                    }
                    return y;
                  }
                }
              }
            }
          }
        },
        {
          title: "Heart Rate",
          icon: "ri-hearts-line",
          value: "110",
          subvalue: "3.2%",
          selectedTimeframe: 'current', // Individual selection for each vital
          yearlyData: {
            // Full year data for line chart
            data: [
              { month: 'Jan', value: 95 },
              { month: 'Feb', value: 98 },
              { month: 'Mar', value: 100 },
              { month: 'Apr', value: 102 },
              { month: 'May', value: 105 },
              { month: 'Jun', value: 108 },
              { month: 'Jul', value: 112 },
              { month: 'Aug', value: 115 },
              { month: 'Sep', value: 112 },
              { month: 'Oct', value: 108 },
              { month: 'Nov', value: 105 },
              { month: 'Dec', value: 110 }
            ]
          },
          // Monthly data for each month (current month is December in this example)
          monthlyData: {
            'January': [92, 95, 98, 96],
            'February': [95, 98, 100, 97],
            'March': [98, 100, 102, 99],
            'April': [100, 102, 105, 103],
            'May': [102, 105, 108, 106],
            'June': [105, 108, 110, 107],
            'July': [108, 112, 115, 110],
            'August': [112, 115, 118, 114],
            'September': [110, 112, 115, 112],
            'October': [105, 108, 110, 107],
            'November': [102, 105, 108, 106],
            'December': [110, 105, 100, 108]
          },
          chartData: {
            series: [{
              name: "Current Month",
              data: [110, 105, 100, 108]
            }],
            chartOptions: {
              chart: {
                height: 150,
                type: 'bar',
                zoom: {
                  enabled: false
                },
                toolbar: {
                  show: false
                }
              },
              colors: ['#556ee6'],
              dataLabels: {
                enabled: false,
              },
              stroke: {
                width: [2],
                curve: 'smooth'
              },
              plotOptions: {
                bar: {
                  horizontal: false,
                  columnWidth: '45%',
                  endingShape: 'rounded'
                },
              },
              grid: {
                row: {
                  colors: ['transparent', 'transparent'],
                  opacity: 0.2
                },
                borderColor: '#f1f1f1'
              },
              markers: {
                size: 3
              },
              xaxis: {
                categories: ['Week 1', 'Week 2', 'Week 3', 'Week 4'],
                labels: {
                  show: false
                },
                axisBorder: {
                  show: false
                },
                axisTicks: {
                  show: false
                }
              },
              yaxis: {
                labels: {
                  show: false
                }
              },
              legend: {
                show: false
              },
              tooltip: {
                shared: true,
                intersect: false,
                y: {
                  formatter: function (y) {
                    if (typeof y !== "undefined") {
                      return y.toFixed(0) + " bpm";
                    }
                    return y;
                  }
                }
              }
            }
          }
        },
        {
          title: "Cholesterol",
          icon: "ri-flask-line",
          value: "180",
          subvalue: "2.1%",
          selectedTimeframe: 'current', // Individual selection for each vital
          yearlyData: {
            // Full year data for line chart
            data: [
              { month: 'Jan', value: 175 },
              { month: 'Feb', value: 178 },
              { month: 'Mar', value: 182 },
              { month: 'Apr', value: 185 },
              { month: 'May', value: 188 },
              { month: 'Jun', value: 190 },
              { month: 'Jul', value: 192 },
              { month: 'Aug', value: 190 },
              { month: 'Sep', value: 188 },
              { month: 'Oct', value: 185 },
              { month: 'Nov', value: 182 },
              { month: 'Dec', value: 180 }
            ]
          },
          // Monthly data for each month (current month is December in this example)
          monthlyData: {
            'January': [172, 175, 178, 176],
            'February': [175, 178, 180, 177],
            'March': [180, 182, 185, 183],
            'April': [182, 185, 188, 186],
            'May': [185, 188, 190, 187],
            'June': [188, 190, 192, 190],
            'July': [190, 192, 195, 193],
            'August': [188, 190, 192, 190],
            'September': [185, 188, 190, 187],
            'October': [182, 185, 188, 186],
            'November': [180, 182, 185, 183],
            'December': [180, 185, 190, 178]
          },
          chartData: {
            series: [{
              name: "Current Month",
              data: [180, 185, 190, 178]
            }],
            chartOptions: {
              chart: {
                height: 150,
                type: 'bar',
                zoom: {
                  enabled: false
                },
                toolbar: {
                  show: false
                }
              },
              colors: ['#556ee6'],
              dataLabels: {
                enabled: false,
              },
              stroke: {
                width: [2],
                curve: 'smooth'
              },
              plotOptions: {
                bar: {
                  horizontal: false,
                  columnWidth: '45%',
                  endingShape: 'rounded'
                },
              },
              grid: {
                row: {
                  colors: ['transparent', 'transparent'],
                  opacity: 0.2
                },
                borderColor: '#f1f1f1'
              },
              markers: {
                size: 3
              },
              xaxis: {
                categories: ['Week 1', 'Week 2', 'Week 3', 'Week 4'],
                labels: {
                  show: false
                },
                axisBorder: {
                  show: false
                },
                axisTicks: {
                  show: false
                }
              },
              yaxis: {
                labels: {
                  show: false
                }
              },
              legend: {
                show: false
              },
              tooltip: {
                shared: true,
                intersect: false,
                y: {
                  formatter: function (y) {
                    if (typeof y !== "undefined") {
                      return y.toFixed(0) + " mg/dL";
                    }
                    return y;
                  }
                }
              }
            }
          }
        }
      ]
    };
  },
  mounted() {
    // Initialize charts with correct data based on default timeframe
    this.vitalsData.forEach((vital, index) => {
      this.updateChartData(index);
    });
  },
  methods: {
    // Get meter level based on vital type and value
    getMeterLevel(vitalType, value) {
      switch(vitalType) {
        case "BP Levels": {
          const systolic = parseInt(value.split('/')[0]);
          if (systolic < 120) return "Normal";
          if (systolic < 130) return "Elevated";
          if (systolic < 140) return "Stage 1";
          if (systolic < 180) return "Stage 2";
          return "Crisis";
        }

        case "Sugar Levels": {
          const sugar = parseInt(value);
          if (sugar < 100) return "Normal";
          if (sugar < 126) return "Prediabetes";
          return "Diabetes";
        }

        case "Heart Rate": {
          const hr = parseInt(value);
          if (hr < 60) return "Low";
          if (hr <= 100) return "Normal";
          return "High";
        }

        case "Cholesterol": {
          const chol = parseInt(value);
          if (chol < 200) return "Desirable";
          if (chol < 240) return "Borderline";
          return "High";
        }

        default:
          return "Unknown";
      }
    },

    // Update the timeframe for a specific vital
    updateTimeframe(index, value) {
      // Update the selected timeframe for the specific vital
      this.vitalsData[index].selectedTimeframe = value;

      // Update chart data and options based on the selected timeframe
      this.updateChartData(index);
    },

    // Update chart data and options based on the selected timeframe
    updateChartData(index) {
      const vital = this.vitalsData[index];
      const timeframe = vital.selectedTimeframe;
      const color = this.chartColors[index];

      // Set chart type based on timeframe
      const chartType = timeframe === 'all' ? 'line' : 'bar';

      // Enhanced chart options
      const enhancedOptions = {
        chart: {
          type: chartType,
          height: 180,
          zoom: { enabled: false },
          toolbar: { show: false },
          animations: {
            enabled: true,
            easing: 'easeinout',
            speed: 800,
            animateGradually: {
              enabled: true,
              delay: 150
            },
            dynamicAnimation: {
              enabled: true,
              speed: 350
            }
          },
          dropShadow: {
            enabled: true,
            top: 3,
            left: 2,
            blur: 4,
            opacity: 0.1
          }
        },
        colors: [color],
        dataLabels: {
          enabled: false,
        },
        stroke: {
          width: chartType === 'line' ? 3 : 0,
          curve: 'smooth',
          lineCap: 'round'
        },
        grid: {
          borderColor: '#f1f1f1',
          row: {
            colors: ['transparent', 'transparent'],
            opacity: 0.2
          },
          padding: {
            top: 0,
            right: 0,
            bottom: 0,
            left: 0
          }
        },
        markers: {
          size: chartType === 'line' ? 4 : 0,
          colors: [color],
          strokeColors: '#fff',
          strokeWidth: 2,
          hover: {
            size: 6
          }
        },
        tooltip: {
          theme: 'dark',
          shared: true,
          intersect: false,
          y: {
            formatter: function (y) {
              if (typeof y !== "undefined") {
                const units = {
                  "BP Levels": " mmHg",
                  "Sugar Levels": " mg/dL",
                  "Heart Rate": " bpm",
                  "Cholesterol": " mg/dL"
                };
                return y.toFixed(0) + (units[vital.title] || "");
              }
              return y;
            }
          }
        },
        legend: {
          show: false
        },
        xaxis: {
          labels: {
            show: true,
            style: {
              colors: [],
              fontSize: '10px',
              fontFamily: 'Helvetica, Arial, sans-serif',
              fontWeight: 400,
              cssClass: 'apexcharts-xaxis-label',
            }
          },
          axisBorder: {
            show: false
          },
          axisTicks: {
            show: false
          }
        },
        yaxis: {
          labels: {
            show: false
          }
        }
      };

      // Add specific options for bar charts
      if (chartType === 'bar') {
        enhancedOptions.plotOptions = {
          bar: {
            horizontal: false,
            columnWidth: '45%',
            endingShape: 'rounded',
            borderRadius: 4,
            distributed: false,
            dataLabels: {
              position: 'top'
            }
          }
        };
        enhancedOptions.fill = {
          type: 'gradient',
          gradient: {
            shade: 'light',
            type: "vertical",
            shadeIntensity: 0.25,
            gradientToColors: undefined,
            inverseColors: true,
            opacityFrom: 0.85,
            opacityTo: 0.65,
            stops: [50, 100]
          }
        };
      }

      // Add specific options for line charts
      if (chartType === 'line') {
        enhancedOptions.fill = {
          type: 'gradient',
          gradient: {
            shade: 'light',
            type: "vertical",
            shadeIntensity: 0.5,
            gradientToColors: undefined,
            inverseColors: true,
            opacityFrom: 0.7,
            opacityTo: 0.2,
            stops: [0, 100]
          }
        };
      }

      // Update chart options with enhanced options
      vital.chartData.chartOptions = { ...vital.chartData.chartOptions, ...enhancedOptions };

      // Update series data based on timeframe
      if (timeframe === 'all') {
        // For 'all', use yearly data in line chart format
        vital.chartData.series = [{
          name: "Yearly Trend",
          data: vital.yearlyData.data.map(item => item.value)
        }];

        // Update x-axis categories to months
        vital.chartData.chartOptions.xaxis.categories = vital.yearlyData.data.map(item => item.month);
      } else {
        // For specific month or current month
        const monthData = timeframe === 'current' ? vital.monthlyData['December'] : vital.monthlyData[timeframe];

        // Update series with the selected month's data
        vital.chartData.series = [{
          name: timeframe === 'current' ? "Current Month" : timeframe,
          data: monthData
        }];

        // Update x-axis categories to weeks
        vital.chartData.chartOptions.xaxis.categories = ['Week 1', 'Week 2', 'Week 3', 'Week 4'];
      }
    }
  }
};
</script>

<template>
  <div>
    <div class="row">
      <!-- Responsive grid: xs=1 card, sm=2 cards, md=2 cards, lg=4 cards per row -->
      <div class="col-sm-6 col-lg-3" v-for="(vital, index) in vitalsData" :key="index">
        <div class="card mb-3 shadow-sm" :class="`vital-card-${index}`">
          <!-- Card header with improved layout -->
          <div class="card-header bg-gradient-light py-2">
            <!-- Vital sign title and icon with better spacing -->
            <div class="d-flex align-items-center mb-2">
              <div class="avatar-sm rounded-circle bg-soft-primary mr-3 d-flex align-items-center justify-content-center">
                <i :class="`${vital.icon} font-size-18 text-primary`"></i>
              </div>
              <h5 class="font-weight-bold mb-0">{{ vital.title }}</h5>
            </div>
            
            <!-- Value and status with improved visual hierarchy -->
            <div class="d-flex justify-content-between align-items-center">
              <div>
                <div class="d-flex align-items-center">
                  <h3 class="mb-0 font-weight-bold">{{ vital.value }}</h3>
                  <span class="badge ml-2" :class="parseFloat(vital.subvalue) > 0 ? 'badge-soft-success' : 'badge-soft-danger'">
                    <i :class="parseFloat(vital.subvalue) > 0 ? 'mdi mdi-arrow-up-bold' : 'mdi mdi-arrow-down-bold'"></i>
                    {{ vital.subvalue }}
                  </span>
                </div>
                <!-- Meter level label with better visibility -->
                <div class="mt-1">
                  <span class="badge badge-soft-primary p-2">
                    {{ getMeterLevel(vital.title, vital.value) }}
                  </span>
                </div>
              </div>
              
              <!-- Timeframe Selector moved to right side for better balance -->
              <div class="form-group mb-0">
                <select 
                  class="form-control form-control-sm custom-select border-0 bg-soft-light" 
                  v-model="vital.selectedTimeframe"
                  @change="updateTimeframe(index, vital.selectedTimeframe)"
                  aria-label="Select timeframe"
                >
                  <option v-for="option in timeframeOptions" :key="option.value" :value="option.value">
                    {{ option.text }}
                  </option>
                </select>
              </div>
            </div>
          </div>

          <!-- Chart section with improved visibility -->
          <div class="card-body p-2">
            <!-- Always show chart with placeholder for current timeframe -->
            <div class="border rounded p-1 bg-soft-light shadow-sm">
              <div v-if="vital.selectedTimeframe === 'current'" class="text-center py-4">
                <p class="text-muted mb-0">Select a timeframe to view trend data</p>
              </div>
              <apexchart
                v-else
                class="apex-charts"
                height="180"
                :type="vital.chartData.chartOptions.chart.type"
                dir="ltr"
                :series="vital.chartData.series"
                :options="vital.chartData.chartOptions"
              ></apexchart>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
/* Background styles */
.bg-gradient-light {
  background: linear-gradient(to right, #f8f9fa, #ffffff);
}

/* Soft background colors */
.bg-soft-primary {
  background-color: rgba(85, 110, 230, 0.15) !important;
}

.bg-soft-success {
  background-color: rgba(52, 195, 143, 0.15) !important;
}

.bg-soft-danger {
  background-color: rgba(244, 106, 106, 0.15) !important;
}

.bg-soft-light {
  background-color: rgba(248, 249, 250, 0.5) !important;
}

/* Text colors */
.text-success {
  color: #34c38f !important;
}

.text-danger {
  color: #f46a6a !important;
}

.text-primary {
  color: #556ee6 !important;
}

/* Avatar styles */
.avatar-sm {
  height: 3rem;
  width: 3rem;
}

.avatar-xs {
  height: 2rem;
  width: 2rem;
}

.avatar-title {
  align-items: center;
  display: flex;
  height: 100%;
  justify-content: center;
  width: 100%;
}

/* Card styles */
.card {
  transition: all 0.3s ease;
  border-radius: 0.5rem;
  overflow: hidden;
}

.card:hover {
  transform: translateY(-3px);
  box-shadow: 0 0.5rem 1rem rgba(0,0,0,0.15) !important;
}

.card-header {
  border-bottom: 1px solid rgba(0,0,0,0.05);
}

.shadow-sm {
  box-shadow: 0 .125rem .25rem rgba(0,0,0,.075) !important;
}

/* Button styles */
.btn-soft-primary {
  background-color: rgba(85, 110, 230, 0.15);
  border-color: transparent;
  color: #556ee6;
}

.btn-soft-primary:hover {
  background-color: #556ee6;
  color: #fff;
}

/* Form control styles */
.custom-select {
  transition: all 0.3s ease;
  font-size: 0.8rem;
  max-width: 120px;
}

.custom-select:focus {
  box-shadow: none;
  border-color: #556ee6;
}

/* Vital card color coding */
.vital-card-0 {
  border-top: 3px solid #556ee6;
}

.vital-card-1 {
  border-top: 3px solid #34c38f;
}

.vital-card-2 {
  border-top: 3px solid #f1b44c;
}

.vital-card-3 {
  border-top: 3px solid #50a5f1;
}

/* Badge styles */
.badge-soft-primary {
  color: #556ee6;
  background-color: rgba(85, 110, 230, 0.18);
  font-weight: 500;
  font-size: 0.75rem;
}

.badge-soft-success {
  color: #34c38f;
  background-color: rgba(52, 195, 143, 0.18);
  font-weight: 500;
  font-size: 0.75rem;
}

.badge-soft-danger {
  color: #f46a6a;
  background-color: rgba(244, 106, 106, 0.18);
  font-weight: 500;
  font-size: 0.75rem;
}

/* Chart container */
.border.rounded {
  min-height: 120px;
  display: flex;
  align-items: center;
  justify-content: center;
}

/* Responsive adjustments */
@media (max-width: 576px) {
  .card-header {
    padding: 0.75rem;
  }
  
  h3 {
    font-size: 1.5rem;
  }
  
  .custom-select {
    max-width: 100px;
  }
}
</style>
